export const AUTH_LOGIN_REQUEST = 'auth/login-request'
export const AUTH_LOGIN_SUCCESS = 'auth/login-success'
export const AUTH_LOGIN_FAILED = 'auth/login-failed'
